import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import App from "./App.tsx";
import "./index.css";
import "./locales/i18n.ts";
import { configureAppStore } from "./store/configureStore.ts";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./mui/theme.ts";

const store = configureAppStore();
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster
          richColors
          position="top-right"
          closeButton
          expand
          duration={2000}
        />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
